import { UnsignedSignature } from "@/types/reward";
import * as userRequest from "@/utils/userRequest";

export default async function getUnsignedSignature(
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get("/user/unsigned-signature", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log("🚀 ~ getUnsignedSignature ~ res:", res);

        if (res) {
            const data: UnsignedSignature[] = res.data
                ?.map((item: any) => ({
                    rank_id: item.rank_id,
                    level: item.level,
                    rank_name: item.rank_name,
                }))
                .sort((a: any, b: any) => a.level - b.level);
            onSuccess && onSuccess(data);
            return data;
        }
    } catch (err) {
        console.error("🚀 ~ getUnsignedSignature ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
